import React from "react";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import ItemCard from "../ItemCard";

const RecipeBranch = (props) => {
  const { itemId, index, depth, mapBranch } = props;

  const { useNewRiotItems } = getRiotAssetsContext();
  const { data } = useNewRiotItems({ itemId: itemId, ssr: true });
  const itemData = data?.[itemId];

  if (!itemData) return <div></div>;

  const calculateBranchType = (depth, mapBranch, index) => {
    let itemCount = 0;

    if (index === 0) {
      return `branch-${depth}-${itemCount}`;
    }

    // looping through the item components before this specific item
    for (let i = 0; i < index; i++) {
      // checking if the item before has components (In the same tree branch)
      if (mapBranch[i]) {
        const singleKey = Object.keys(mapBranch[i])[0];

        if (singleKey !== "0" && mapBranch[i][singleKey]?.length > 0) {
          itemCount += mapBranch[i][singleKey].length;
        }
      }

      // always add +1 for the base item
      itemCount += 1;
    }

    return `branch-${depth}-${itemCount}`;
  };

  const components = itemData?.from ? itemData.from : itemData?.specialRecipe ? [itemData?.specialRecipe] : [];

  return (
    <div className="branch-container">
      <div className="branch-main">
        <div className={calculateBranchType(depth, mapBranch, index)}></div>
        <div>
          <ItemCard itemId={itemId} />
          {components?.map((componentId, i) => (
            <RecipeBranch
              key={`${componentId}-${i}-${depth}`}
              itemId={componentId}
              index={i}
              depth={depth + 1}
              mapBranch={mapBranch && mapBranch[index][itemId]}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecipeBranch;
